"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobProgress = void 0;
/**
 * A Job Progress
 *
 * This must be a class acting as the API/SDK interface
 * (The class is serialized and sent through HTTP, we don't want missing fields
 * making the response returned by the server inconsistent)
 */
class JobProgress {
    /**
     * Creates a new instance of Job Progress which includes
     * all the values of a Job Progress for transferring within servers/clients
     *
     * @param obj The minimal required parameters for creating a Job Progress
     */
    constructor(obj) {
        this.current = 0;
        this.total = 100;
        this.current = obj.current;
        this.total = obj.total || 100;
        this.msg = obj.msg || "";
        this.err = obj.err || "";
        this.updatedOn = obj.updatedOn || Date.now();
    }
}
exports.JobProgress = JobProgress;
//# sourceMappingURL=job-progress.js.map